import { defineMessages } from '@jutro/locale';

export default defineMessages({
    yourDocumentsTitle: {
        id: 'claim.views.claim-documents.Your documents',
        defaultMessage: 'Your documents'
    },
    statusDotNotOk: {
        id: 'claim.views.claim-documents.confirmation.statusDotNotOk',
        defaultMessage: '●   '
    },
    confirmationLabelPleaseComplete: {
        id: 'claim.views.claim-documents.Please complete the information',
        defaultMessage: 'Please complete the information'
    },
    confirmationLabelInProcessing: {
        id: 'claim.views.claim-documents.In processing by ADAC',
        defaultMessage: 'In processing by ADAC'
    },
    claimNumber: {
        id: 'claim.views.claim-documents.Claim number',
        defaultMessage: 'Claim number { claimNumber }'
    },
    confidentiality: {
        id: 'claim.views.claim-documents.Confidentiality signed',
        defaultMessage: 'Confidentiality signed'
    },
    statusDotOk: {
        id: 'claim.views.claim-documents.confirmation.statusDotOk',
        defaultMessage: '   ●'
    },
    documentsSentLabel: {
        id: 'claim.views.claim-documents.Documents sent',
        defaultMessage: 'Documents sent'
    },
    uploadDocumentsButton: {
        id: 'claim.views.claim-documents.Upload document',
        defaultMessage: 'Upload document'
    },
    next: {
        id: 'claim.views.claim-documents.Next',
        defaultMessge: 'Next'
    },
    howItWorksLabel: {
        id: 'claim.views.claim-documents.Thats how it works',
        defaultMessage: 'That\'s how it works'
    },
    howItWorksDescription: {
        id: 'claim.views.claim-documents.confirmation.We have received your documents',
        defaultMessage: 'We have received your documents and will now check them. As soon as new information about your case is available, you will be notified by SMS.'
    },
    viewDocuments: {
        id: 'claim.views.claim-documents.List of already uploaded documents',
        defaultMessage: 'List of already uploaded documents'
    },
    fetchFailed: {
        id: 'claim.views.claim-cw.An error has occurred...',
        defaultMessage: 'An error has occurred...'
    },
    fetchFailedTitle: {
        id: 'claim.views.claim-cw.Claim Details',
        defaultMessage: 'Claim Details'
    },
    uploadAdditionalDocuments: {
        id: 'claim.views.claim-cw.Here you can upload additional documents',
        defaultMessage: 'Here you can upload additional documents.'
    }
});
